import { render } from "./PantryImageRoomView.vue?vue&type=template&id=4d17ac8b&ts=true"
import script from "./PantryImageRoomView.vue?vue&type=script&lang=ts"
export * from "./PantryImageRoomView.vue?vue&type=script&lang=ts"

import "./PantryImageRoomView.vue?vue&type=style&index=0&id=4d17ac8b&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__